import { Chain } from '@ankr.com/chains-list';

import { getGroupedEndpoints } from 'modules/endpoints/utils/getGroupedEndpoints';
import { getChainGroups } from 'modules/endpoints/constants/groups';

export const hasWsFeature = (chain: Chain): boolean => {
  const { devnet, mainnet, testnet } = getGroupedEndpoints({
    chain,
    groups: getChainGroups(),
  });

  return [...mainnet, ...testnet, ...devnet]
    .flatMap(item => item.urls)
    .some(url => url.ws);
};
